import { Checkbox } from '@components/checkbox';
import { useCallback, useState } from 'react';
import { useFragment } from 'react-relay';
import { otherDocumentsFragment } from './OtherDocuments.relay';
import DocumentsDropdown from './dropdown';
import getOtherDocumentsLabel from './label';
import type { OtherDocumentsGraphQLProps, OtherDocumentsPropsType } from './types';

const OtherDocuments: React.FC<OtherDocumentsPropsType> = (props) => {
  const documentLabels = useFragment(otherDocumentsFragment, props.documentLabels);

  const [expanded, setExpanded] = useState(false);

  const hideDropdown = useCallback((e = null) => {
    const timeout = /(Trident.+?11|MSIE 10)/.test(navigator.userAgent) ? 100 : 0;

    if (e) {
      e.preventDefault();
    }

    setTimeout(() => {
      setExpanded(false);
    }, timeout);
  }, []);

  const toggleDropdown = useCallback(() => {
    if (expanded) {
      hideDropdown();
    } else {
      setExpanded((prev) => !prev);
    }
  }, [expanded, hideDropdown]);

  const blur = useCallback(
    (e) => {
      const al = document.activeElement;
      const ct = e.currentTarget;

      if (!ct.contains(al)) {
        hideDropdown();
      }
    },
    [hideDropdown],
  );

  const fixedLabel = props.fixedLabel ? props.fixedLabel : null;
  const useShortLabel = props.excludedColsInOtherDocs.length <= 1;

  const otherDocumentLabels = documentLabels.labels.filter((label) => props.excludedColsInOtherDocs.indexOf(label.key) < 0);

  return (
    <div className={`-mt-1 OtherDocuments relative w-[200px] focus:outline-none max-[600px]:w-full ${expanded ? 'OtherDocuments-expanded' : ''}`} onBlur={blur}>
      <Checkbox
        className={`AboTable-OtherDocuments-dropdown relative text-accent [&_.Checkbox-label]:relative [&_.Checkbox-label]:z-10 [&_.Checkbox-label]:overflow-hidden [&_.Checkbox-label]:text-ellipsis [&_.Checkbox-label]:whitespace-nowrap [&_.Checkbox-label]:pr-[25px] after:absolute after:right-0 after:top-0 after:z-0 after:h-5 after:w-[25px] after:bg-[url(/static/front/assets/chevron/_chevron-down.svg)] after:bg-position-[right_5px_center] after:bg-no-repeat after:transition-transform ${expanded ? 'after:rotate-180' : ''}`}
        checked={props.otherDocuments.otherall === 1}
        indeterminate={props.otherDocuments.otherall === 2}
        onClick={(e) => {
          e.preventDefault();
          toggleDropdown();
        }}
        checkboxClickUpdate={(newVal) => {
          props.checkFn(
            typeof props.id === 'string' ? [props.id] : props.id,
            otherDocumentLabels.map((label) => label.key),
            newVal,
          );
        }}
        label={
          fixedLabel
            ? fixedLabel
            : getOtherDocumentsLabel(
                props.otherDocuments.other,
                otherDocumentLabels,
                props.otherDocuments.otherall,
                useShortLabel,
                documentLabels.documentLabelsTitle,
                documentLabels.furtherDocumentLabelsTitle,
                documentLabels.allDocumentLabelsTitle,
              )
        }
      />
      <DocumentsDropdown id={props.id} checkFn={props.checkFn} documentsChecked={props.otherDocuments.other} documentLabels={otherDocumentLabels} isVisible={expanded} />
    </div>
  );
};

export { OtherDocuments };
export type { OtherDocumentsGraphQLProps };
